import React, { useState, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';
import AIcon from '../../components/partials/AIcon';
import LogsDataModal from '../../components/modals/LogsDataModal';
//import NewRole from './NewRole';

const TABLE_HEAD = ["No.", "Model", "Log Type", "IP", 'Message', "Browser", "Changes", "Creator", 'Updated At', 'Actions'];
const breadcrumbs = [{ name: 'لاگز', link: '/logs' }]
const menuData = [
  { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1] },
]
const searchInputFields = [
  { label: 'Model', name: 'model', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
  { label: 'Log Type', name: 'action', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', options: [] },
  { label: 'IP', name: 'ip', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },
  { label: 'Creator', name: 'creator', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },

];



export default function Logs() {
  const [showChanges, setShowChanges] = useState(null)

  const { com, setModel, models, setShowViewDialog, showDeleteDialog, setShowDeleteDialog } = useShared();

  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)


    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };

  const openChangesDialog = (changes) => {
    setShowChanges(changes)
    console.log(changes);
  }

  const handleViewDialog = (obj) => {
    return [
      { l: 'Name', v: obj?.name },
      { l: 'Type', v: obj?.parent?.label },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {

    return (<tbody className=''>
      {models?.data?.map((r, i) => {
        return (
          <Fragment key={i}>
            {setTableData(r, i)}
          </Fragment>)
      })}
    </tbody>)
  }

  const setTableData = (r, i) => {

    return (
      <tr key={r.id} className={` !text-sm`}>
        <td >{models?.from + i} </td>
        <th > {r?.model?.split('\\').pop()}</th>
        <th > <span className={` ${r?.action==="DELETED"?'text-red-500':r?.action==="CREATED"?'text-green-600':'text-purple-700'}`}>{r?.action}</span> </th>
        <td>{r?.ip}</td>
        <td >{r?.message}</td>
        <td >{r?.browser}</td>
        <td className='text-center'> <AIcon className="text-green-700 cursor-pointer" size={20} name="eye" onClick={() => openChangesDialog(r?.changes)} /> </td>
        <td>{r?.user?.full_name}</td>
        <td style={{ direction: 'ltr' }}>{com.dateConvert(r?.created_at, false, true)}</td>
        <td >
          <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

        </td></tr>)
  }


  return (
    <>
      <MainSection v={{
        handleViewDialog,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        url: "logs",
        modelName: { name: 'logs', af: 'لاکز' },
        mUrl: { delete: 'logs', create: 'logs', getAll: 'logs' },
        tableTitle: 'ليست لاکز',
        advanceSearch: 'logs',

        modelScreen: 'Categories',
      }} />

      <LogsDataModal v={{ showChanges, setShowChanges }} />
    </>
  )
}
